import { Component, Input, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LayoutService } from '../layout.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss']
})
export class ContainerComponent implements OnInit, AfterViewInit {

  @Input() layoutClasses: string = '';
  isHeroVisible: boolean;
  heroSubscription: Subscription;

  constructor(
    private router: Router,
    private layoutService: LayoutService,
    private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    // console.log('Hero Visible' + this.isHeroVisible);
    //  subcribe to changes on the layoutservice's hero subscription
    this.heroSubscription = this.layoutService.heroItem
      .subscribe(
        item => {
          this.isHeroVisible = item;
        });

    // always scroll to the top of the page
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

  }

  ngAfterViewInit() {

    // detect the changes in the set LayoutClasses
    this.changeDetectorRef.detectChanges();

  }

  setLayoutClasses() {

    return this.isHeroVisible ?
      '' :
      'content';
  }

}



// WEBPACK FOOTER //
// ./client/app/core/layout/secure/container/container.component.ts